import { breadcrumb } from './breadcrumb';

export const notify = {
  breadcrumb,

  notification: {
    field: {
      type: 'Type',
      text: 'Text',
      created_at: 'Date'
    },

    senders_update: {
      body: 'Sender {name} status changed to {status}.',
      success_amount: 'Sender {name} has been approved. You will be charged {amount} a month.',
      success: 'Sender {name} has been approved.',
      error: 'Sender {name} has been rejected.',
      on_deactivation: 'The sender {name} will be deactivated within 1-3 days.',
      text_link: 'Go to page'
    },

    mailings_update: {
      moderation_success:
        'SMS mailing {name} approved. The dispatch will take place on {start_at}.',
      moderate_too_late:
        'SMS {name} was not approved before the scheduled time of sending. Mailigs rejected.',
      pending: 'SMS mailing {name} approved.',
      rejected: 'SMS mailing {name} rejected.',
      failed: 'SMS mailing {name} failed.'
    },

    rates_update: {
      body:
        'Your service tariff has been updated. Please see the detailed information on the page "{link}".',

      type: {
        messaging: 'sms',
        voice: 'voice communication',
        hlr: 'HLR',
        default: 'communication',
        number_verification: 'verification'
      },

      link: {
        label: 'Rates'
      }
    },

    low_balance: {
      body:
        'Your account has insufficient funds. Please replenish your balance to continue using ZORRA services.'
    },

    not_enough_money: {
      body: 'There are not enough funds on the balance for HLR verification of the file'
    },

    documents_update: {
      body: {
        approved: 'Document is approved.',
        rejected: 'Document is rejected. Contact support for the details.'
      }
    },

    export_complete: {
      body: 'Your export file is ready.',
      link: 'Download'
    },

    recording_export_complete: {
      body: 'Your export file is ready.',
      link: 'Download'
    },

    empty_records: {
      body: 'No call records for the selected period'
    },

    button: {
      see_all: 'See all'
    },

    export_type: {
      mailing_export_complete: 'SMS',
      senders_update: 'Senders',
      mailings_update: 'Mailings',
      voice_export_complete: 'Voice',
      database_export_complete: 'DB',
      pbx_export_complete: 'PBX',
      recording_export_complete: 'PBX recording',
      stat_export_complete: 'Autoinformer',
      documents_update: 'Profile',
      rates_update: 'Rates update',
      low_balance: 'Low balance',
      custom: 'Notification',
      not_enough_money: 'Not enough funds',
      predictive_export_stats_complete : "Predictive"
    }
  }
};
